import styled, { keyframes } from 'styled-components';
import { colors } from '../../utils/colors';

const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const LoadingWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: ${props => props.fullScreen ? '100vh' : '200px'};
  padding: 2rem;
`;

const Spinner = styled.div`
  width: ${props => props.size || '40px'};
  height: ${props => props.size || '40px'};
  border: 3px solid ${colors.backgroundLight};
  border-top-color: ${colors.primary};
  border-radius: 50%;
  animation: ${spin} 0.8s linear infinite;
`;

const LoadingText = styled.p`
  margin-top: 1rem;
  color: ${colors.textLight};
  font-size: ${props => props.fontSize || '1rem'};
  text-align: center;
`;

export const Loading = ({ 
  text = 'Cargando...', 
  size, 
  fontSize,
  fullScreen = false
}) => {
  return (
    <LoadingWrapper 
      fullScreen={fullScreen}
      role="alert" 
      aria-busy="true" 
      aria-label={text}
    >
      <Spinner size={size} />
      <LoadingText fontSize={fontSize} aria-hidden="true">
        {text}
      </LoadingText>
    </LoadingWrapper>
  );
};